<template>
  <div>

    <el-descriptions direction="vertical" :column="1" border>
      <el-descriptions-item>
        <template slot="label">
          <span class="require-flag">*</span>和申请方向的相关度
        </template>
        <el-select
          v-model="project_list.direction_type"
          placeholder="请选择状态"
        >
          <el-option
            v-for="(item,index) in kDirectionOptions"
            :key="index"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item v-if="project_list.direction_type">
        <template slot="label">
          <p class="third-title-p">
            <span class="require-flag">*</span>1：申请动机：你为什么申请这个专业？（建议字数300-500）
            <span style="color: red" @click="()=>requirmentDialog = kPSBaseinfoWriteRequirment(project_list.direction_type)"
            >点击查看要求></span
            >
          </p>
        </template>
        <el-input
          type="textarea"
          :placeholder="kPSBaseinfoWriteRequirment(project_list.direction_type)"
          v-model="project_list.con_1"
          rows="6"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item  v-if="project_list.direction_type">
        <template slot="label">
          <p class="third-title-p">
            <span class="require-flag">*</span>2：职业规划（建议字数150-200 )
            <span style="color: red" @click="()=>requirmentDialog = kPSBaseinfoWriteRequirment('职业规划')"
            >点击查看要求></span
            >
          </p>
        </template>
        <el-input
          type="textarea"
          v-model="project_list.con_2"
          :placeholder="kPSBaseinfoWriteRequirment('职业规划')"
          rows="6"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item  v-if="project_list.direction_type">
        <template slot="label">
          <p class="third-title-p">
            <span class="require-flag">*</span>3：选校/项目原因（建议字数＜200）
            <span style="color: red" @click="()=>requirmentDialog = kPSBaseinfoWriteRequirment('选校/项目原因')"
            >点击查看要求></span
            >
          </p>
        </template>
        <el-input
          type="textarea"
          :placeholder="kPSBaseinfoWriteRequirment('选校/项目原因')"
          v-model="project_list.con_3"
          rows="6"
        ></el-input>
      </el-descriptions-item>
<!--      <el-descriptions-item  v-if="project_list.direction_type">-->
<!--        <template slot="label">-->
<!--          <p class="third-title-p">-->
<!--            <span class="require-flag">*</span>4：学术竞争力（建议200-400字，优先选跟申请方向项目相关的）-->
<!--            <span style="color: red" @click="()=>requirmentDialog = kPSBaseinfoWriteRequirment('学术竞争力')"-->
<!--            >点击查看要求></span-->
<!--            >-->
<!--          </p>-->
<!--        </template>-->
<!--        <el-input-->
<!--          type="textarea"-->
<!--          :placeholder="kPSBaseinfoWriteRequirment('学术竞争力')"-->
<!--          v-model="project_list.con_4"-->
<!--          rows="6"-->
<!--        ></el-input>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item  v-if="project_list.direction_type">-->
<!--        <template slot="label">-->
<!--          <p class="third-title-p">-->
<!--            5：实践竞争力（建议200-400字，优先选跟申请方向项目相关的）-->
<!--            <span style="color: red" @click="()=>requirmentDialog = kPSBaseinfoWriteRequirment('实践竞争力')"-->
<!--            >点击查看要求></span-->
<!--            >-->
<!--          </p>-->
<!--        </template>-->
<!--        <el-input-->
<!--          type="textarea"-->
<!--          :placeholder="kPSBaseinfoWriteRequirment('实践竞争力')"-->
<!--          v-model="project_list.con_5"-->
<!--          rows="6"-->
<!--        ></el-input>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item  v-if="project_list.direction_type">-->
<!--        <template slot="label">-->
<!--          <p class="third-title-p">-->
<!--            6：其他补充:是否有其它经历，但无法确定是对申请有帮助？（建议＜300字）-->
<!--            <span style="color: red" @click="()=>requirmentDialog = kPSBaseinfoWriteRequirment('其他补充')"-->
<!--            >点击查看要求></span-->
<!--            >-->
<!--          </p>-->
<!--        </template>-->
<!--        <el-input-->
<!--          type="textarea"-->
<!--          :placeholder="kPSBaseinfoWriteRequirment('其他补充')"-->
<!--          v-model="project_list.con_6"-->
<!--          rows="6"-->
<!--        ></el-input>-->
<!--      </el-descriptions-item>-->
    </el-descriptions>
    <el-dialog
      title="填写要求"
      center
      :visible="requirmentDialog && requirmentDialog.length > 0"
      width="50%"
      @close="requirmentDialog=null"
    >
      <p style="white-space: pre-wrap;font-size: 16px;">{{ requirmentDialog }}</p>
    </el-dialog>
  </div>
</template>
<script>
import {
  ps_baseinfo_write_requirment,
} from "../HBCommon/placeholder";
export default {
  name:"TabProjectV1",
  components: {
  },
  props: {
    user_profile:{
      default: ''
    }
  },
  watch: {
    'user_profile': {
      handler(val, oldVal) {
        // console.log('传入方向数据：' ,val)
        // console.log('传入方向数据数字：' ,val.length)
        // console.log('传入方向数据类型：' ,typeof val)
        if(val){
          console.log('进来了：' ,val)
          this.project_list = val
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      requirmentDialog: false,
      project_list: {
        direction_type: '',
        con_1: '',
        con_2: '',
        con_3: '',
        con_4: '',
        con_5: '',
        con_6: ''
      }
    }
  },
  computed: {
    kDirectionOptions() {
      return [
        {
          value: '本专业申请'
        },
        {
          value: '有相关背景的转专业申请'
        },
        {
          value: '无相关背景的转专业申请'
        }
      ]
    }
  },
  methods: {
    kPSBaseinfoWriteRequirment(key) {
      return ps_baseinfo_write_requirment(key)
    }
  }
}
</script>
<style scoped lang="scss">
.require-flag {
  font-size: 20px !important;
  font-weight: 550 !important;
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_project_v1.vue